
  import {Component, Vue} from "vue-property-decorator";
  import breadcrumb from "@/components/common/breadcrumb.vue";
  import {getConfig, getOverviewExcel, getOverviewList} from '@/services/api';
  import store from "@/store";
  import {OverviewReq, OverviewResp} from "@/model/Report";
  import {dateFormat, handleExcelRes} from "@/services/common";

  @Component({
    components: {'zf-breadcrumb': breadcrumb},
  })
  export default class ReportOverview extends Vue {
    // 控制列表高度
    public tableHeight: number = window.innerHeight - 200;
    // 地区
    public countryList: {code: string, name: string}[] = [];
    // 列表数据
    public tableData: OverviewResp[] = [];
    // 日期
    public date: string[] = [dateFormat(new Date(), 'yyyy-MM-dd'), dateFormat(new Date(), 'yyyy-MM-dd')];
    // 上传表单
    public formData: OverviewReq = {
      viewType: 0,
      pageNum: 1,
      pageSize: 20
    }
    indexInfo = {
      pageNum: 1,
      pageSize: 20
    }
    // 列表总数
    public totalNum = 0
    // excel下载截流控制
    public excelCtrl = true;

    public pickerOptions = {
      shortcuts: [{
        text: '最近一周',
        onClick(picker: any) {
          const end = new Date(), start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
          picker.$emit('pick', [start, end]);
        }
      }, {
        text: '最近一个月',
        onClick(picker: any) {
          const end = new Date(), start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
          picker.$emit('pick', [start, end]);
        }
      }, {
        text: '最近三个月',
        onClick(picker: any) {
          const end = new Date(), start = new Date();
          start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
          picker.$emit('pick', [start, end]);
        }
      }]
    }
    /**
     * 初始化方法
     */
    async created(): Promise<void> {
      window.onresize = () => {
        try {
          this.tableHeight = window.innerHeight - 200;
        } catch (e) {}
      }
      await this.getOverviewList();
      this.getConfig();
    }

    async getOverviewList() {
      this.formData.startDate = this.date && this.date[0];
      this.formData.endDate = this.date && this.date[1];
      await getOverviewList(this.formData).then(res => {
        if (res.data.code === 200) {
          this.tableData = res.data.data.list || [];
          this.totalNum =  res.data.data.total || 0;
          this.indexInfo = {
            pageNum: this.formData.pageNum,
            pageSize: this.formData.pageSize
          };
        } else {
          this.$message.error(res.data.message);
        }
      })
    }

    /**
     * 获取字典信息
     */
    getConfig(): void {
      if (!this.$store.state.region || this.$store.state.region.length === 0) {
        getConfig({type: 'region'}).then(res => {
          if (res.data && res.data.status === 'OK') {
            this.countryList = res.data.result || [];
            store.commit('SET_REGION', this.countryList);
          }
        })
      } else {
        this.countryList = this.$store.state.region;
      }
    }

    /**
     * 数据导出
     */
    async getExcel(): Promise<void>  {
      if (this.excelCtrl) {
        this.excelCtrl = false;
        try {
          await getOverviewExcel(this.formData).then((res: any) => {
            handleExcelRes(res);
          })
        } catch (e) {}
        this.excelCtrl = true;
      }
    }

    /**
     * 重置
     */
    reset(): void {
      this.formData = {
        pageNum: this.formData.pageNum,
        pageSize: this.formData.pageSize,
        viewType: this.formData.viewType
      };
      this.date = [dateFormat(new Date(), 'yyyy-MM-dd'), dateFormat(new Date(), 'yyyy-MM-dd')];
    }

    /**
     * 查询
     */
    search(): void {
      this.formData.pageNum = 1;
      this.getOverviewList();
    }

    /**
     * 分页大小变化
     * @param val
     */
    handleSizeChange(val: number): void {
      this.formData.pageSize = val;
      this.formData.pageNum = 1;
      this.getOverviewList();
    }

    /**
     * 当前页面变化
     * @param val
     */
    handleCurrentChange(val: number): void {
      this.formData.pageNum = val;
      this.getOverviewList();
    }

    /**
     * 序号控制
     * @param index
     */
    indexMethod(index: number) {
      return (this.indexInfo.pageNum - 1) * this.indexInfo.pageSize + index + 1;
    }

  }

